import { WidgetLegendSettings } from "components/settingsConfig/uiComponents/SettingsLegend";

export type ChordChartSettingsStateType = WidgetLegendSettings & {
  colorBy: "source" | "target";
  customWidgetTitle: string;
  widgetTitle: string;
  widgetTitleAlignment: string;
};

export const chordChartDefaultSettings: ChordChartSettingsStateType = {
  colorBy: "source",
  customWidgetTitle: '',
  widgetTitle: 'default',
  widgetTitleAlignment: 'left',
};